import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
//import {AppDataActions} from "../../redux/app-data";

import Kambi from './kambi/kambi';
import Global from '../../global';
import Breadcrumbs from './breadcrumbs/breadcrumbs';
import RoutedContent from '../../routing/routed-content';
import { is888SpecificRoute } from '../../routing/routing-lib';
import getRoutes from '../../routing/routes';
import { publishTopicOnChannel } from '../../services/external-pub-sub/pub-sub-utils';
import { eTopics, eChannels, ePublishers } from '../../utils/enums';

if (process.env.BROWSER) {
  require('./main-layout.scss');
}

class MainLayout extends React.Component {
  mainContentId = 'SC-main-page-content';
  state = {
    showLoader: true
  };

  /*loadOpenBets() {
    const {dispatch, userContext} = this.props;
    dispatch(AppDataActions.loadOpenBets());

    const timeInterval = Global.config.openBetsPollingInterval;
    clearInterval(this.openBetsRequestInterval);
    this.openBetsRequestInterval = setInterval(() => {
      if (userContext.isLoggedIn) {
        dispatch(AppDataActions.loadOpenBets())
      }
    }, timeInterval);
  }*/

  stopListeningForOpenBets() {
    //clearInterval(this.openBetsRequestInterval);
  }

  componentDidMount() {
    const is888SpecificRoute = this.is888Route();
    if (is888SpecificRoute && this.state.showLoader) {
      const homePageContainer = document.getElementById(this.mainContentId);
      const hasVisibleContent = this.hasVisibleContent(
        homePageContainer.offsetHeight
      );

      if (hasVisibleContent) {
        this.setState({ showLoader: false });
        this.hideLoader();
      } else {
        const mutationObserverConfig = {
          attributes: true,
          childList: true,
          subtree: true
        };
        const observer = new MutationObserver(this.observerCallback);
        observer.observe(homePageContainer, mutationObserverConfig);
      }
    }

    /*if (this.props.userContext.isLoggedIn) {
      this.loadOpenBets();
    } else {
      this.stopListeningForOpenBets();
    }*/
  }

  componentDidUpdate(prevProps) {
    const is888SpecificRoute = this.is888Route();
    if (
      !prevProps.isKambiLoaded &&
      this.props.isKambiLoaded &&
      this.state.showLoader &&
      !is888SpecificRoute
    ) {
      this.setState({ showLoader: false });
      this.hideLoader();
    }

    /*if (!prevProps.userContext.isLoggedIn && this.props.userContext.isLoggedIn) {
      this.loadOpenBets();
    } else if (prevProps.userContext.isLoggedIn && !this.props.userContext.isLoggedIn) {
      this.stopListeningForOpenBets()
    }*/
  }

  componentWillUnmount() {
    this.setState({ showLoader: true });
    this.stopListeningForOpenBets();
  }

  observerCallback = (mutationsList, observer) => {
    const homePageContainer = document.getElementById(this.mainContentId);
    const hasVisibleContent = this.hasVisibleContent(
      homePageContainer.offsetHeight
    );

    if (hasVisibleContent) {
      this.setState({ showLoader: false });
      this.hideLoader();
      observer.disconnect();
    }
  };

  hasVisibleContent = height => {
    const necessaryHeight = 500;
    return height >= necessaryHeight;
  };

  is888Route = () => {
    // removed "#/" from the beginning of window.location.hash
    const hashValue =
      typeof window !== 'undefined' ? window.location.hash.slice(2) : '';
    return is888SpecificRoute(hashValue);
  };

  shouldShowBreadcrumbs = () => {
    const is888SpecificRoute = this.is888Route();
    return Global.config.enableBreadcrumbs && is888SpecificRoute;
  };

  hideLoader = () => {
    const { cid, isLoggedIn } = this.props.userContext;
    if (cid && isLoggedIn)
      publishTopicOnChannel(
        eTopics.session.clientInitSucceeded,
        eChannels.session,
        'hideLoader();',
        null,
        { publisher: ePublishers.sportclient }
      );
  };

  render() {
    const { kambiConfigData, isBreadcrumbReady } = this.props;
    const showBreadcrumbs = this.shouldShowBreadcrumbs();
    const mainContentClassName = classnames('main-page-content', {
      'main-content-with-breadcrumb': isBreadcrumbReady
    });
    const routes = getRoutes();

    return (
      <Fragment>
        {showBreadcrumbs && (
          <RoutedContent component={Breadcrumbs} routes={routes} />
        )}

        <div id={this.mainContentId} className={mainContentClassName}>
          <RoutedContent routes={routes} />
          <Kambi kambiConfigData={kambiConfigData} />
        </div>
      </Fragment>
    );
  }
}

MainLayout.propTypes = {
  kambiConfigData: PropTypes.object,
  isKambiLoaded: PropTypes.bool,
  isBreadcrumbReady: PropTypes.bool,
  userContext: PropTypes.object,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    isKambiLoaded: state.appUI.isKambiLoaded,
    isBreadcrumbReady: state.breadcrumbs.isBreadcrumbReady,
    userContext: state.userContext
  };
}

export default connect(mapStateToProps)(MainLayout);
